import React from "react";
import "./PicturesAndVideosSlider.scss";
import DataNotFound from "component/shared/DataNotFound/DataNotFound";
import { END_POINTS } from "constants/APIConstant";
import useSWR from "swr";
import ContentLoading from "component/LoadingComponent/ContentLoading";
import { DateFormater } from "functions/dateTimeFormat";
import { API_BASE_URL } from "configs/AppConfig";
import AOS from "aos";
import "aos/dist/aos.css";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import LabelLang from "component/LabelLang/label-lang";
import Modal from "react-bootstrap/Modal";

function PicturesAndVideosSlider() {
  const carouselRef = React.useRef(null);
  const previewCarouselRef = React.useRef(null);
  const autoplayIntervalRef = React.useRef(null);

  // Preview state
  const [show, setShow] = React.useState(false);
  const [selectedAlbumId, setSelectedAlbumId] = React.useState(null);
  const [imagePreview, setImagePreview] = React.useState("");
  const [currentSlideIndex, setCurrentSlideIndex] = React.useState(0);

  React.useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  const photoAlbum = useSWR({
    url: `${END_POINTS.PINNED_PHOTOS}`,
  });

  // Fetch album details for preview
  // const albumDetails = useSWR({
  //   url: selectedAlbumId
  //     ? `${END_POINTS.PHOTO_ALBUM_DETAILS}?photoAlbumId=${selectedAlbumId}`
  //     : null,
  // });

  const myList = [
    {
      imgSlide: process.env.PUBLIC_URL + "/image/mediaLandingNews.png",
      title: `اجتماع السيد رئيس الجهاز مع السيدة الينا بانوفا الممثل المقيم
      للأمم المتحدة بمصر`,
      date: "أكتوبـر 2022",
    },
    {
      imgSlide: process.env.PUBLIC_URL + "/image/news1.png",
      title: `اجتماع السيد رئيس الجهاز مع السيدة الينا بانوفا الممثل المقيم
      للأمم المتحدة بمصر`,
      date: "أكتوبـر 2022",
    },
    {
      imgSlide: process.env.PUBLIC_URL + "/image/newsr2.png",
      title: `اجتماع السيد رئيس الجهاز مع السيدة الينا بانوفا الممثل المقيم
      للأمم المتحدة بمصر`,
      date: "أكتوبـر 2022",
    },
    {
      imgSlide: process.env.PUBLIC_URL + "/image/news2.png",
      title: `اجتماع السيد رئيس الجهاز مع السيدة الينا بانوفا الممثل المقيم
      للأمم المتحدة بمصر`,
      date: "أكتوبـر 2022",
    },
    {
      imgSlide: process.env.PUBLIC_URL + "/image/newsr2.png",
      title: `اجتماع السيد رئيس الجهاز مع السيدة الينا بانوفا الممثل المقيم
      للأمم المتحدة بمصر`,
      date: "أكتوبـر 2022",
    },
    {
      imgSlide: process.env.PUBLIC_URL + "/image/newsr3.png",
      title: `اجتماع السيد رئيس الجهاز مع السيدة الينا بانوفا الممثل المقيم
      للأمم المتحدة بمصر`,
      date: "أكتوبـر 2022",
    },
    {
      imgSlide: process.env.PUBLIC_URL + "/image/flags.png",
      title: `اجتماع السيد رئيس الجهاز مع السيدة الينا بانوفا الممثل المقيم
      للأمم المتحدة بمصر`,
      date: "أكتوبـر 2022",
    },
    {
      imgSlide: process.env.PUBLIC_URL + "/image/tv.png",
      title: `اجتماع السيد رئيس الجهاز مع السيدة الينا بانوفا الممثل المقيم
      للأمم المتحدة بمصر`,
      date: "أكتوبـر 2022",
    },
    {
      imgSlide: process.env.PUBLIC_URL + "/image/newsr2.png",
      title: `اجتماع السيد رئيس الجهاز مع السيدة الينا بانوفا الممثل المقيم
      للأمم المتحدة بمصر`,
      date: "أكتوبـر 2022",
    },
  ];

  const handleClose = () => {
    setShow(false);
    setSelectedAlbumId(null);
    setImagePreview("");
    // The useEffect will handle restoring autoplay
  };

  const handleShow = (albumId, image, clickedIndex) => {
    // Save current slider position and stop all movement
    if (carouselRef.current) {
      let carousel = null;
      const carouselEl = carouselRef.current;
      if (carouselEl?.carousel) carousel = carouselEl.carousel;
      if (carouselEl?.owlCarousel) carousel = carouselEl.owlCarousel;

      if (!carousel) {
        const sliderElement = document.querySelector(
          "#photoAlbum-testimonoals"
        );
        if (
          sliderElement &&
          window.$ &&
          window.$(sliderElement).data("owl.carousel")
        ) {
          carousel = window.$(sliderElement).data("owl.carousel");
        }
      }

      if (carousel) {
        // Get current position (use clickedIndex if provided, otherwise get current)
        const current =
          clickedIndex !== undefined ? clickedIndex : carousel.current();
        setCurrentSlideIndex(current);

        // Immediately stop autoplay and any movement
        try {
          carousel.trigger("stop.owl.autoplay");
          if (carousel.settings) {
            carousel.settings.autoplay = false;
          }
          if (carousel._plugins && carousel._plugins.autoplay) {
            carousel._plugins.autoplay.stop();
          }
          // Go to the clicked item to ensure it's visible
          carousel.to(current, 0);
        } catch (error) {
          console.error("Error stopping carousel:", error);
        }
      }
    }

    setSelectedAlbumId(albumId);
    setImagePreview(image);
    setShow(true);
  };

  // Stop/Start autoplay based on modal state
  React.useEffect(() => {
    const getCarousel = () => {
      let carousel = null;
      if (carouselRef.current) {
        const carouselEl = carouselRef.current;
        if (carouselEl?.carousel) carousel = carouselEl.carousel;
        if (carouselEl?.owlCarousel) carousel = carouselEl.owlCarousel;
      }

      if (!carousel) {
        const sliderElement = document.querySelector(
          "#photoAlbum-testimonoals"
        );
        if (
          sliderElement &&
          window.$ &&
          window.$(sliderElement).data("owl.carousel")
        ) {
          carousel = window.$(sliderElement).data("owl.carousel");
        }
      }
      return carousel;
    };

    if (show) {
      // Stop autoplay and freeze slider when modal opens
      const timeoutId = setTimeout(() => {
        const carousel = getCarousel();
        if (carousel) {
          try {
            // Multiple methods to stop autoplay
            carousel.trigger("stop.owl.autoplay");

            // Clear any existing autoplay interval
            if (autoplayIntervalRef.current) {
              clearInterval(autoplayIntervalRef.current);
              autoplayIntervalRef.current = null;
            }

            // Disable autoplay in settings
            if (carousel.settings) {
              carousel.settings.autoplay = false;
            }

            // Try to get the autoplay instance and stop it
            if (carousel._plugins && carousel._plugins.autoplay) {
              carousel._plugins.autoplay.stop();
            }

            // Go to the current slide index to freeze position
            carousel.to(currentSlideIndex, 0);

            // Also try jQuery method
            if (window.$) {
              const $carousel = window.$("#photoAlbum-testimonoals");
              if ($carousel.length) {
                $carousel.trigger("stop.owl.autoplay");
                $carousel.trigger("to.owl.carousel", [currentSlideIndex, 0]);
              }
            }
          } catch (error) {
            console.error("Error stopping autoplay:", error);
          }
        }
      }, 10);

      return () => {
        clearTimeout(timeoutId);
      };
    } else {
      // Restore autoplay when modal closes
      const timeoutId = setTimeout(() => {
        const carousel = getCarousel();
        if (carousel) {
          try {
            // Restore position first
            carousel.to(currentSlideIndex, 300);

            // Wait a bit before restarting autoplay
            setTimeout(() => {
              const carousel2 = getCarousel();
              if (carousel2) {
                // Enable autoplay in settings
                if (carousel2.settings) {
                  carousel2.settings.autoplay = true;
                }

                // Restart autoplay
                carousel2.trigger("play.owl.autoplay", [5000]);

                // Also try jQuery method
                if (window.$) {
                  const $carousel = window.$("#photoAlbum-testimonoals");
                  if ($carousel.length) {
                    $carousel.trigger("play.owl.autoplay", [5000]);
                  }
                }
              }
            }, 300);
          } catch (error) {
            console.error("Error restarting autoplay:", error);
          }
        }
      }, 100);

      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [show, currentSlideIndex]);

  const renderPhotoAlbum = () => {
    const photoos =
      photoAlbum.error ||
      photoAlbum.isLoading ||
      photoAlbum.data === undefined ||
      photoAlbum.data === null
        ? []
        : photoAlbum.data.data;

    const rendering = photoos.map(({ image, publishingDate, photoAlbum }, i) =>
      Object.keys(photoos).length > 0 ? (
        <div key={i} className="item-sd">
          <img
            className="img1"
            src={image ? `${API_BASE_URL}/${image}` : myList[0].imgSlide}
            alt="swiper-img"
            loading="lazy"
            style={{ cursor: "pointer" }}
            onClick={() => {
              if (photoAlbum?.id) {
                handleShow(photoAlbum.id, image, i);
              }
            }}
          />
          <h5>
            <LabelLang
              id="title"
              defaultValue={photoAlbum?.title}
              translations={photoAlbum?.photoAlbumTranslations}
            />
          </h5>
          <h6>
            <DateFormater value={publishingDate} type={"monthYear"} />
          </h6>
        </div>
      ) : (
        <DataNotFound />
      )
    );

    return rendering;
  };

  // Render photos for preview modal - show all pinned albums
  const renderPreviewPhotos = () => {
    const photoos =
      photoAlbum.error ||
      photoAlbum.isLoading ||
      photoAlbum.data === undefined ||
      photoAlbum.data === null
        ? []
        : photoAlbum.data.data;

    if (photoos.length === 0) return null;

    // Find the index of the clicked album
    const previewIndex = photoos.findIndex((item) => {
      return (
        item.photoAlbum?.id === selectedAlbumId || item.image === imagePreview
      );
    });
    const startIndex = previewIndex >= 0 ? previewIndex : currentSlideIndex;

    // Reorder albums to start with the clicked album
    const reorderedAlbums = [
      ...photoos.slice(startIndex),
      ...photoos.slice(0, startIndex),
    ];

    return reorderedAlbums.map(({ image, publishingDate, photoAlbum }, i) => (
      <div key={i} className="item">
        <img
          style={{ height: "400px", objectFit: "cover", width: "100%" }}
          src={
            image
              ? `${API_BASE_URL}/${image}`
              : myList[0]?.imgSlide ||
                process.env.PUBLIC_URL + "/image/newsr1.png"
          }
          alt="preview-item"
          loading="lazy"
        />
        <div style={{ marginTop: "1rem", textAlign: "center" }}>
          <h5
            style={{
              fontSize: "1.1rem",
              fontWeight: "bold",
              marginBottom: "0.5rem",
            }}
          >
            <LabelLang
              id="title"
              defaultValue={photoAlbum?.title}
              translations={photoAlbum?.photoAlbumTranslations}
            />
          </h5>
          <h6 style={{ fontSize: "0.9rem", color: "#6b7280" }}>
            <DateFormater value={publishingDate} type={"monthYear"} />
          </h6>
        </div>
      </div>
    ));
  };

  const options = {
    loop: true,
    center: true,
    margin: 30,
    responsiveClass: true,
    autoplay: true,
    dots: false,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    smartSpeed: 500,
    nav: true,
    dir: "ltr",
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 1,
      },
      768: {
        items: 3,
      },
      992: {
        items: 3,
      },
      1200: {
        items: 5,
      },
    },
  };

  const previewOptions = {
    loop: false,
    center: true,
    margin: 0,
    responsiveClass: true,
    autoplay: false,
    dots: true,
    smartSpeed: 600,
    nav: true,
    items: 1,
    dir: "ltr",
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    freeDrag: false,
    stagePadding: 0,
    merge: false,
    mergeFit: true,
    autoWidth: false,
    startPosition: 0,
    URLhashListener: false,
    navText: ["‹", "›"],
    slideBy: 1,
    slideTransition: "linear",
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    animateOut: "fadeOut",
    animateIn: "fadeIn",
  };

  // Keyboard navigation for main slider
  React.useEffect(() => {
    if (show) return; // Don't handle keyboard for main slider when modal is open

    const handleKeyDown = (event) => {
      // Get carousel instance
      let carousel = null;
      if (carouselRef.current) {
        const carouselEl = carouselRef.current;
        if (carouselEl?.carousel) carousel = carouselEl.carousel;
        if (carouselEl?.owlCarousel) carousel = carouselEl.owlCarousel;
      }

      // Try to get from DOM using jQuery (OwlCarousel uses jQuery)
      if (!carousel) {
        const sliderElement = document.querySelector(
          "#photoAlbum-testimonoals"
        );
        if (
          sliderElement &&
          window.$ &&
          window.$(sliderElement).data("owl.carousel")
        ) {
          carousel = window.$(sliderElement).data("owl.carousel");
        }
      }

      if (!carousel) return;

      // Check if slider is in viewport
      const sliderElement = document.querySelector(".PicturesAndVideosSlider");
      if (!sliderElement) return;

      const rect = sliderElement.getBoundingClientRect();
      const isInViewport = rect.top < window.innerHeight && rect.bottom > 0;

      if (!isInViewport) return;

      // Handle arrow keys
      if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
        // Prevent default only if slider is focused or in viewport
        const isInputFocused =
          document.activeElement?.tagName === "INPUT" ||
          document.activeElement?.tagName === "TEXTAREA";

        if (isInputFocused) return; // Don't interfere with input fields

        event.preventDefault();
        event.stopPropagation();

        try {
          if (event.key === "ArrowLeft") {
            carousel.prev();
          } else if (event.key === "ArrowRight") {
            carousel.next();
          }
        } catch (error) {
          console.error("Error navigating carousel:", error);
        }
      }
    };

    // Add event listener with a delay to ensure carousel is initialized
    const timeoutId = setTimeout(() => {
      window.addEventListener("keydown", handleKeyDown);
    }, 500);

    // Cleanup
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [show]);

  // Keyboard navigation for preview modal
  React.useEffect(() => {
    if (!show) return; // Only enable keyboard navigation when modal is open

    const handleKeyDown = (event) => {
      // Get carousel instance
      let carousel = null;
      if (previewCarouselRef.current) {
        const carouselEl = previewCarouselRef.current;
        if (carouselEl?.carousel) carousel = carouselEl.carousel;
        if (carouselEl?.owlCarousel) carousel = carouselEl.owlCarousel;
      }

      // Try to get from DOM using jQuery (OwlCarousel uses jQuery)
      if (!carousel) {
        const sliderElement = document.querySelector("#preview-album-slider");
        if (
          sliderElement &&
          window.$ &&
          window.$(sliderElement).data("owl.carousel")
        ) {
          carousel = window.$(sliderElement).data("owl.carousel");
        }
      }

      if (!carousel) return;

      // Handle arrow keys
      if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
        event.preventDefault();
        event.stopPropagation();

        try {
          if (event.key === "ArrowLeft") {
            carousel.prev();
          } else if (event.key === "ArrowRight") {
            carousel.next();
          }
        } catch (error) {
          console.error("Error navigating carousel:", error);
        }
      }

      // Handle Escape key to close modal
      if (event.key === "Escape") {
        handleClose();
      }
    };

    // Add event listener when modal is open
    // Use a small delay to ensure carousel is initialized
    const timeoutId = setTimeout(() => {
      window.addEventListener("keydown", handleKeyDown);
    }, 100);

    // Cleanup
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [show]);

  return (
    <ContentLoading isLoading={photoAlbum.isLoading}>
      <div
        className="PicturesAndVideosSlider"
        data-aos="fade-down"
        data-aos-duration="1000"
        data-aos-easing="ease-in-sine"
        tabIndex={0}
      >
        {Object.keys(renderPhotoAlbum()).length > 0 ? (
          <OwlCarousel
            ref={carouselRef}
            id="photoAlbum-testimonoals"
            className="owl-theme"
            {...options}
          >
            {renderPhotoAlbum()}
          </OwlCarousel>
        ) : (
          <DataNotFound />
        )}
      </div>

      {/* Preview Modal */}
      <Modal
        style={{ zIndex: "9999999999" }}
        show={show}
        onHide={handleClose}
        centered
        size="lg"
      >
        <Modal.Body style={{ padding: "1.5rem", textAlign: "center" }}>
          <ContentLoading isLoading={photoAlbum.isLoading}>
            {Object.keys(renderPreviewPhotos() || []).length > 0 ? (
              <OwlCarousel
                ref={previewCarouselRef}
                id="preview-album-slider"
                className="owl-carousel owl-theme"
                {...previewOptions}
              >
                {renderPreviewPhotos()}
              </OwlCarousel>
            ) : (
              <div style={{ padding: "2rem" }}>
                <DataNotFound />
              </div>
            )}
          </ContentLoading>
        </Modal.Body>
      </Modal>
    </ContentLoading>
  );
}

export default PicturesAndVideosSlider;
